import { Injectable, inject } from '@angular/core';

import { SharedFeaturesApiService } from '@frontend/vanilla/core';
import { Observable } from 'rxjs';

/**
 * @experimental
 */
@Injectable({
    providedIn: 'root',
})
export class EdsGroupResourceService {
    private api = inject(SharedFeaturesApiService);

    getGroupOptinStatus(groupId: string | null): Observable<EdsGroupOptinStatus> {
        return this.api.get(`edsgroup/${groupId}`);
    }

    updateCampaignOptinStatus(campaignId: string, optIn = true) {
        return this.api.post(`edsgroup/${campaignId}/${optIn}`);
    }
}

export interface EdsGroupOptinStatus {
    campaignDetails: CampaignDetails[];
}

export interface CampaignDetails {
    id: number;
    optInStatus: string;
}
